import React, { ChangeEvent, FocusEvent, KeyboardEventHandler } from 'react';
import { TextField } from '@mui/material';
import { themeVars } from '@mds/ui';

interface EditBlockProps {
    placeholder: string | undefined;
    value: string;
    id?: string;
    onBlur?: (event: FocusEvent<any>) => void;
    onChange?: (
        event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => void;
    onKeyPress?: KeyboardEventHandler;
    onKeyUp?: KeyboardEventHandler;
    onKeyDown?: KeyboardEventHandler;
}

export const EditBlock = (props: EditBlockProps) => {
    const inputProps = {
        disableUnderline: true,
        placeholder: props.placeholder,
    };

    return (
        <TextField
            id={props.id}
            sx={{
                alignSelf: 'stretch',
                minWidth: 0,
                width: 1,
                '& .MuiInputBase-root': {
                    width: 1,
                },
                '& .MuiInputBase-input': (theme) => ({
                    ...theme.typography.h4,
                    color: themeVars(theme).palette.text.primary,
                    '&::placeholder': {
                        color: themeVars(theme).palette.text.secondary,
                        opacity: 1,
                    },
                }),
            }}
            multiline={true}
            fullWidth={true}
            value={props.value}
            onBlur={props.onBlur}
            onKeyPress={props.onKeyPress}
            onKeyUp={props.onKeyUp}
            onKeyDown={props.onKeyDown}
            onChange={props.onChange}
            slotProps={{
                input: inputProps,
            }}
        />
    );
};

export default EditBlock;
